import styled from 'styled-components';

export const BenefitsWrapper = styled.div`
	display: grid;
	grid-template-columns: repeat(3, 1fr);
	gap: 20px;

	@media (max-width: 700px) {
		display: flex;
		flex-direction: column;
		gap: 12px;
	}
`;

export const BenefitsElement = styled.div`
	display: flex;
	flex-direction: column;
	background: #ffffff;
	border-radius: 4px;
	align-items: flex-start;
	padding: 32px;

	@media (max-width: 700px) {
		flex-direction: row;
		padding: 16px;
		align-items: center;
	}

	img {
		width: 60px;
		height: 60px;

		@media (max-width: 600px) {
			align-self: flex-start;
			width: 40px;
			height: 40px;
		}
	}
`;

export const TextWrapper = styled.div`
	margin-top: 20px;
	p {
		${({ theme }) => theme.typography.textL};
		color: ${({ theme }) => theme.primaryBlackColor};
		//text-align: center;
		margin: 0;
		//@media (max-width: 700px) {
		//	text-align: left;
		//}
	}

	@media (max-width: 700px) {
		margin-left: 15px;
		margin-top: 0;
	}
`;

export const Text = styled.div`
	margin-top: 10px;
	@media (max-width: 700px) {
		margin: 0;
		${({ theme }) => theme.typography.textS};
	}
`;
